import type { LimitOrderResponse } from 'apiConnector/secondary-market/limit-order/models';
import { secondaryMarketOriginalFormActionsFactory } from 'state/secondaryMarket/shared/form/original/original.actions';

export const limitOrderOriginalFormActions = secondaryMarketOriginalFormActionsFactory<
  'LIMIT_ORDER',
  LimitOrderResponse
>('LIMIT_ORDER');
type TypeofLimitOrderOriginalFormActions = typeof limitOrderOriginalFormActions;
export type SecondaryMarketAmendLimitOrderFetchRequested = ReturnType<
  TypeofLimitOrderOriginalFormActions['secondaryMarketAmendFetchRequested']
>;
export type SecondaryMarketAmendLimitOrderFetched = ReturnType<
  TypeofLimitOrderOriginalFormActions['secondaryMarketAmendFetched']
>;
export type SecondaryMarketAmendLimitOrderFetchFailed = ReturnType<
  TypeofLimitOrderOriginalFormActions['secondaryMarketAmendFetchFailed']
>;
export type SecondaryMarketLimitOrderOriginalFormActions = ReturnType<
  TypeofLimitOrderOriginalFormActions[keyof TypeofLimitOrderOriginalFormActions]
>;
